import React from 'react';
import memoize from 'memoize-one';
import { DatatableEmployeeName } from '../../index';

const activitiesMarkingsColumns = memoize(clickHandler => [
  {
    name: 'Nombre y Rut',
    selector: 'employee_full_name',
    cell: item => (
      <DatatableEmployeeName item={item.employee} withPhoto={false} onClick={() => clickHandler(item, 'show')} />
    ),
    sortable: true,
    grow: '1'
  },
  {
    name: 'Fecha/Hora de Marcación',
    selector: 'time',
    cell: item => item.parsed_date_time,
    sortable: true,
    grow: '1'
  },
  {
    name: 'Dirección de Marcación',
    selector: 'address',
    sortable: true,
    grow: '2'
  },
  {
    name: 'Tipo de Marcación',
    selector: 'time_type',
    cell: item => item.translated_time_type,
    sortable: true,
    grow: '1'
  },
  {
    name: 'Actividad',
    selector: 'activity',
    cell: item => item.activity || '-',
    sortable: true,
    grow: '2'
  }
]);

export default activitiesMarkingsColumns;
